import {
    participantLabels,
    PARTICIPANT_UI_PATH,
    PREVIEW,
    REGISTRATION_FORM,
    EVENT_URL,
    eventBrandingWebsite,
    messageModule,
    EDIT_PROFILE,
    EVENT_REDIRECTION_URL,
    moderationWithMagicLink,
    APP_DESIGNER,
    qaSpeakerView,
    leaderBoardView,
} from 'utils/constants';

const routesPaths = {
    HOME: '/',
    MODERATION: '/moderation',
    MODERATOR_DASHBOARD: '/moderate/:sessionId/:token?',
    PARTICIPANTS: '/:eventId/attendees',
    DASHBOARD: '/:eventId/overview',
    DETAILS: '/:eventId/event-details',
    PARTICIPANTS_DATA_SETTINGS: '/:eventId/setup/custom-fields',
    SESSIONS_DATA_SETTINGS: '/:eventId/setup/sessions',
    REPORTS_DASHBOARD: '/:eventId/reports',
    REPORT_DETAIL: '/:eventId/reports/:reportId',
    DATA_IMPORT:
        '/:eventId/setup/data-import/:tableName?/:sequenceNumber?/:importId?',
    THIRD_PARTY_IMPORT: '/:eventId/setup/third-party-import',
    THIRD_PARTY_IMPORT_DETAIL:
        '/:eventId/setup/third-party-import/:integrationId',
    MATERIALS: '/:eventId/content',
    INTERACTIVE_MAPS: '/:eventId/content/interactive-maps',
    DIRECTORIES: '/:eventId/directories',
    ENGAGEMENT_TOOLS: '/:eventId/engagement',
    GAMIFICATIONS: '/:eventId/engagement/gamification',
    FRONT_OF_ROOM_LEADER_BOARD: `/:eventId/${leaderBoardView}/:gamificationId`,
    MEETINGS: '/:eventId/agenda/meetings',
    COMMUNICATIONS: '/:eventId/communication',
    EMAILS: '/:eventId/communication/emails',
    APP_DESIGNER: `/:eventId/${APP_DESIGNER}`,
    // Entity hubs — must be registered before APP_DESIGNER_DETAIL so
    // "forms" / "directories" / "profiles" are not captured as :pageId
    APP_DESIGNER_FORMS: `/:eventId/${APP_DESIGNER}/forms`,
    APP_DESIGNER_DIRECTORIES: `/:eventId/${APP_DESIGNER}/directories`,
    APP_DESIGNER_PROFILES: `/:eventId/${APP_DESIGNER}/profiles`,
    APP_DESIGNER_ACTIVITY_FEEDS: `/:eventId/${APP_DESIGNER}/activity-feeds`,
    APP_DESIGNER_EXTERNAL_QR_CODES: `/:eventId/${APP_DESIGNER}/external-qr-codes`,
    APP_DESIGNER_DETAIL: `/:eventId/${APP_DESIGNER}/:pageId`,
    WEB_DESIGNER: '/:eventId/web-designer',
    WEBSITE_BUILDER: '/:eventId/website-builder',
    EVENT_LANDING_PAGE: '/landing/:eventId/:token?',
    DATA_IMPORT_DETAIL:
        '/:eventId/setup/data-import/:tableName/:sequenceNumber/:importId',
    LOGIN_CALLBACK: '/login/callback',
    LOGIN: '/login',
    LOGOUT: '/logout',
    ADMIN_LOGIN: '/admin/login',
    EVENT_LOGIN: '/event/login',
    EVENT_WEBSITE: `${eventBrandingWebsite}:eventId/:pageId/:type?`,
    REGISTRATION: '/registration',
    VERIFY_EMAIL: '/verify-email/:token',
    LINK_REDIRECTION: '/link-redirection/:eventId/:pageId',
    PARTICIPANT_PROFILE: `/:eventId/${participantLabels.PARTICIPANTS.toLowerCase()}/:participantId`,
    LOCATION: '/:eventId/agenda/locations',
    CUSTOM_QR_CODES: '/:eventId/more/custom-qr-codes',
    LABELS: '/:eventId/attendees/labels',
    REGISTRATIONS: '/:eventId/setup/registrations',
    REGISTRATION_FORM: `/event/:eventId/${REGISTRATION_FORM}/:pageId`,
    PREVIEW_REGISTRATION_FORM: `/${PREVIEW}/event/:eventId/${REGISTRATION_FORM}/:pageId`,
    SESSIONS: '/:eventId/agenda',
    RESET_PASSWORD: '/reset-password',
    CREATE_PASSWORD: '/create-password',
    FORGOT_PASSWORD: '/forgot-password',
    CREATE_NEW_PASSWORD: '/create-new-password',
    PREVIEW_EVENT_PAGE: `/${PREVIEW}${PARTICIPANT_UI_PATH}`,
    PREVIEW_ACTIVITY_FEED_PAGE: `/${PREVIEW}${PARTICIPANT_UI_PATH}/activity-feed`,
    PREVIEW_PARTICIPANT_EDIT_DETIAL_PAGE: `/${PREVIEW}/event/:eventId/:pageId/${EDIT_PROFILE}`,
    PREVIEW_EXTERNAL_QR_CODE_PAGE: `/${PREVIEW}${PARTICIPANT_UI_PATH}/external-qr-code`,
    PREVIEW_WIDGET_PAGE: `/${PREVIEW}/event/:eventId/:pageId/:widgetId`,
    PREVIEW_SUB_DETAIL_PAGE: `/${PREVIEW}/event/:eventId/:pageId/:typeOfScreen/:widgetId/:itemId?`,
    PREVIEW_SUB_DETAIL_DIRECTORY_PAGE: `/${PREVIEW}/event/:eventId/:pageId/widgets-module/:widgetId/:itemId?/:directoryId?`,

    // New grouped navigation routes
    AGENDA: '/:eventId/agenda',
    AGENDA_MEETINGS: '/:eventId/agenda/meetings',
    AGENDA_COLLECTIONS: '/:eventId/agenda/collections',
    AGENDA_LOCATIONS: '/:eventId/agenda/locations',

    ATTENDEES: '/:eventId/attendees',
    ATTENDEES_LABELS: '/:eventId/attendees/labels',
    ATTENDEES_CUSTOM_FIELDS: '/:eventId/attendees/custom-fields',

    CONTENT: '/:eventId/content',
    CONTENT_INTERACTIVE_MAPS: '/:eventId/content/interactive-maps',

    COMMUNICATION: '/:eventId/communication',
    COMMUNICATION_EMAILS: '/:eventId/communication/emails',

    ENGAGEMENT: '/:eventId/engagement',
    ENGAGEMENT_GAMIFICATION: '/:eventId/engagement/gamification',

    MORE: '/:eventId/more',
    MORE_THIRD_PARTY_IMPORT: '/:eventId/more/third-party-import',
    MORE_CUSTOM_QR_CODES: '/:eventId/more/custom-qr-codes',

    SUPER_ADMIN: {
        REPORTS: '/super-admin/reports',
        APP_VERSIONS: '/super-admin/app-versions',
        REPORT_DETAIL: '/super-admin/reports/:reportId',
        SUPER_ADMIN: '/super-admin',
        ORGANIZATIONS: '/super-admin/organizations',
        EVENT_HUBS: '/super-admin/event-hubs',
        EVENTS: '/super-admin/events',
        ADMIN_USERS: '/super-admin/admin-users',
        LANDING_PAGE_TEMPLATES: '/super-admin/landing-page-templates',
        SYSTEM_LANDING_PAGE_TEMPLATES:
            '/super-admin/system-landing-page-templates',
    },
    ADMINISTRATION: {
        LANDING_PAGE_TEMPLATE_HUBS: '/administration/landing-page-templates',
    },
    HUB_LANDING_PAGE_TEMPLATES:
        '/administration/landing-page-templates/:eventHubId',
    HUB_LANDING_PAGE_TEMPLATE_EDITOR:
        '/administration/landing-page-templates/:eventHubId/:templateId',
    SYSTEM_LANDING_PAGE_TEMPLATE_EDITOR:
        '/super-admin/system-landing-page-templates/:templateId',
    LEGACY_HUB_LANDING_PAGE_TEMPLATES:
        '/event-hubs/:eventHubId/landing-page-templates',
    ADMIN_USERS: {
        ADMIN_USERS: '/administration/admin-users',
    },
    PARTICIPANT_USER: {
        EVENT_DETIAL_PAGE: PARTICIPANT_UI_PATH,
        ACTIVITY_FEED_PAGE: `${PARTICIPANT_UI_PATH}/activity-feed`,
        PARTICIPANT_EDIT_DETIAL_PAGE: `${PARTICIPANT_UI_PATH}/${EDIT_PROFILE}`,
        EXTERNAL_QR_CODE_PAGE: `${PARTICIPANT_UI_PATH}/external-qr-code`,
        EVENT_URL_PAGE: `/${EVENT_URL}/:eventId`,
        REDIRECT_URL_PAGE: `/${EVENT_REDIRECTION_URL}`,
        NO_EVENT_ACCESS: `/no-event-access`,
        WIDGET_DETAIL_PAGE: `${PARTICIPANT_UI_PATH}/:widgetId`,
        SUB_DETAIL_PAGE: `${PARTICIPANT_UI_PATH}/:typeOfScreen/:widgetId/:itemId?`,
        SUB_DETAIL_DIRECTORY_PAGE: `${PARTICIPANT_UI_PATH}/widgets-module/:widgetId/:itemId?/:directoryId?`,
    },
    AGGREGATED_SURVEY_POLL_RESULT:
        '/view-aggregated-result/:eventId/:engagementToolId',
    SURVEY_POLL_RESULT: '/view-result/:eventId/:engagementToolId/:instanceId',
    MODERATE_QA: '/qa/:engagementToolId/:instanceId',
    MODERATE_QA_SPEAKER_VIEW: `/${qaSpeakerView}/:engagementToolId/:instanceId`,
    MODERATE_QA_WITH_MAGIC_LINK: `/${moderationWithMagicLink}/qa/:engagementToolId/:instanceId`,
    MODERATE_QA_SPEAKER_VIEW_WITH_MAGIC_LINK: `/${moderationWithMagicLink}/${qaSpeakerView}/:engagementToolId/:instanceId`,
    POINTR_MAP:
        '/pointr/:clientId/:clientSecret/:siteId/:buildingId/:destinationPoiId?',
};

export default routesPaths;
